<template>
  <div>
    <div v-show="showPage==='首页'">
      <STable
        ref="tableref"
        :url="url"
        :columns="columns"
        :handles="handles"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </div>
    <div v-if="showPage==='详情'">
      <scanDetail :id="dataId" @backHome="backHome()" />
    </div>
    <el-dialog
      v-if="stopDialog"
      v-dialogDrag
      title="终止"
      :visible.sync="stopDialog"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="50%"
      center
    >
      <div style="width: 90%;margin:0 auto">
        <el-form ref="stopFormRef" :model="stopForm" :rules="stopRules" label-width="100px">
          <el-form-item label="终止原因" prop="stopReason">
            <el-input v-model="stopForm.stopReason" type="textarea" :rows="4" placeholder="请输入活动终止原因" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import scanDetail from './scanDetail.vue'
export default {
  components: { scanDetail },
  data() {
    return {
      showPage: '首页',
      dataId: 0,
      stopDialog: false,
      stopId: '', // 活动终止的Id
      url: '/activity/page?type=8',
      columns: [
        {
          label: '活动名称',
          prop: 'name'
        },
        {
          label: '活动状态',
          prop: 'status',
          template: function(index, record) {
            if (record.status === '1') {
              return '未开始'
            } else if (record.status === '2') {
              return '进行中'
            } else if (record.status === '3') {
              return '结束'
            } else if (record.status === '4') {
              return '终止（手动）'
            } else if (record.status === '5') {
              return '终止（自动）'
            }
          }
        },
        {
          label: '活动说明',
          prop: 'description'
        },
        {
          label: '活动开始时间',
          prop: 'start',
          width: '100px'
        },
        {
          label: '活动结束时间',
          prop: 'end',
          width: '100px'
        },
        {
          label: '参与用户数',
          prop: 'userCount',
          template: function(index, record) {
            if (record.userCount) {
              return record.userCount
            } else {
              return 0
            }
          }
        },
        {
          label: '关闭原因',
          prop: 'stopReason'
        },
        {
          label: '修改人',
          prop: 'updateBy'
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          width: '150px'
        }
      ],
      handles: {
        width: 340,
        btns: [
          {
            label: '详情',
            permission: 'activity.scanningCoupon.details',
            handle: record => {
              this.dataId = record.id
              // this.showPage = '详情'
                            this.$router.push({
                 path:'./scanDetail',
                 query:{
                  id:this.dataId,
                 }
              })
            }
          },
          {
            label: '修改',
            permission: 'activity.scanningCoupon.update',
            getLabelDisabled: record => {
              return record.status !== '1'
            },
            handle: record => {
              const data = {
                id: record.id
              }
              this.$router.push({
                path: 'scanModify',
                query: data
              })
            }
          },
          {
            label: '终止',
            permission: 'activity.scanningCoupon.terminate',
                        style:'color:red',
            getLabelDisabled: record => {
              return record.status > 2
            },
            handle: resp => {
              this.stopId = resp.id
              this.stopDialog = true
            }
          },
          {
            label: '下载活动二维码',
            permission: 'activity.scanningCoupon.DownloadCode',
            handle: resp => {
              const url = HOST + '/activity/exportQrCode?width=200&height=200&activityId=' + resp.id
              $.fileDownload(url, {
				  httpMethod: 'get',
				  data: {
				    token: window.localStorage.getItem('token')
				  },
				  failCallback: (html, url) => {
				    this.$notify({
				      title: '失败',
				      message: '下载失败',
				      type: 'error'
				    })
				  }
              })
            }
          }
        ]
      },
      query: [
        {
          label: '活动名称',
          prop: 'name',
          placeholder: '请输入活动名称'
        },
        {
          label: '活动状态',
          prop: 'status',
          placeholder: '请选择活动状态',
          type: 'select',
          data: [{
            label: '未开始',
            value: '1'
          }, {
            label: '进行中',
            value: '2'
          }, {
            label: '结束',
            value: '3'
          }, {
            label: '终止（手动）',
            value: '4'
          }, {
            label: '终止（自动）',
            value: '5'
          }]
        },
        {
          label: '活动开始日期',
          prop: 'start',
          placeholder: '',
          type: 'date3'
        },
        {
          label: '活动结束日期',
          prop: 'end',
          placeholder: '',
          type: 'date3'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'activity.scanningCoupon.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'scanAdd'
            })
          }
        }
      ],
      stopForm: {
        stopReason: ''// 终止原因
      },
      stopRules: {
        stopReason: [
          { required: true, message: '请输入活动终止原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 关闭终止的弹窗
     */
    closeDialog() {
      this.stopId = ''
      this.stopForm.stopReason = ''
      this.stopDialog = false
      this.$refs.tableref.queryTable()
    },
    /**
     * 终止原因提交
     */
    onSubmit() {
      let stopFormBool = false
      this.$refs['stopFormRef'].validate(valid => {
        stopFormBool = valid
      })
      if (stopFormBool) {
        const data = {
          id: this.stopId,
          stopReason: this.stopForm.stopReason
        }
        this.$store.dispatch('form/handle', {
          url: '/activity/stop',
          data: data,
          method: 'post',
          callback: resp => {
            this.$notify({
              title: '成功',
              message: '活动终止成功',
              type: 'success',
              duration: 1500
            })
            this.closeDialog()
          }
        })
      }
    },
    /**
     * 返回首页
     */
    backHome() {
      this.showPage = '首页'
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
           /deep/ .is-disabled{
     color: #C0C4CC !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/scanGet.vue